<template>
  <ReflectionCard class="mt-10">
    <template #header>
      <span class="flex justify-between items-center">
        <span>Now what?</span>
        <div class="flex items-center">
          <action-message
            :on="this.is_saved"
            message="Your changes have been saved."
          ></action-message>
          <button
            type="button"
            @click="saveReflection"
            class="
              px-4
              py-1.5
              border border-gray-300
              rounded-md
              text-xs
              font-medium
              text-gray-700
              bg-white
              hover:bg-gray-50
              focus:outline-none
            "
          >
            Save
          </button>
        </div>
      </span>
    </template>
    <template #content>
      <div class="text-dark-grey text-xxs">
        <p>
          Did you experience any knowledge gaps? Are there certain areas that you think you would
          benefit from developing further? What would you do differently next time, if anything?
        </p>
        <br />
        <p class="mb-3">eg. ’What can I learn from or do differently next time’</p>
      </div>
      <textarea
        rows="4"
        v-model="this.now_what_field"
        class="w-full border border-gray-200 rounded"
      ></textarea>
    </template>
  </ReflectionCard>
</template>

<script>
import ReflectionCard from './Components/ReflectionCard.vue';
import ActionMessage from '@/Jetstream/ActionMessage.vue';

export default {
  name: 'NowWhatCard',
  components: { ReflectionCard, ActionMessage },
  data() {
    return {
      now_what_field: this.$page.props.session.reflection?.now_what,
      is_saved: '',
    };
  },
  methods: {
    saveReflection() {
      this.is_saved = true;
      const data = {
        column: 'now_what',
        value: this.now_what_field,
        session_id: this.$page.props.session.id,
      };
      this.$emit('reflectionChanged', data);
      setTimeout(() => {
        this.is_saved = false;
      }, 2000);
    },
  },
};
</script>

<style scoped></style>
